import { render, staticRenderFns } from "./resource-chart.vue?vue&type=template&id=0be90aa8&scoped=true&"
import script from "./resource-chart.vue?vue&type=script&lang=ts&"
export * from "./resource-chart.vue?vue&type=script&lang=ts&"
import style0 from "./resource-chart.vue?vue&type=style&index=0&id=0be90aa8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be90aa8",
  null
  
)

export default component.exports